<template>
    <v-dialog v-model="dialog" scrollable persistent max-width="500px" :fullscreen="$vuetify.breakpoint.smAndDown">
        <v-card flat outlined rounded v-if="dialog && quest">
            <v-card-title class="justify-end">
                <v-btn icon color="primary" @click="dialog = false">
                    <v-icon>fas fa-times</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <quest-tips :quest="quest" v-if="isVisibleTipsView" />
                <preview-screen
                    :quest="quest"
                    :selected-days="weekdays"
                    :experiences="questExperiences"
                    :rhythm-title="rhythmTitle"
                    :rhythm-type="quest.rhytm ? quest.rhytm.name : null"
                    gallery-path="uploads"
                    v-else
                />
            </v-card-text>
            <v-card-actions>
                <v-btn
                    class="primary"
                    block
                    depressed
                    x-large
                    :loading="saving"
                    @click="onActivateQuestClick"
                    v-if="isActivateBtnVisible"
                >
                    {{ $t('save and activate') }}
                </v-btn>
                <v-btn
                    color="primary"
                    block
                    depressed
                    x-large
                    @click="dialog = false"
                    v-if="isVisibleTipsView"
                >
                    {{ $t('Complete') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';
import { ActivityModel } from '../models';
import PreviewScreen from './QuestWizard/SubComponents/PreviewScreen';
import QuestTips from './QuestWizard/SubComponents/QuestTips';

import { getWeekdays } from '../services/dates';

export default {
    components: {
        PreviewScreen,
        QuestTips,
    },
    props: {
        value: {
            type: Boolean,
        },
        questId: {
            type: Number,
        },
        showActivateButton: {
            type: Boolean,
            default: false,
        },
        showTipsView: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            quest: null,
            savedQuest: null,
            activated: false,
            isVisibleTipsView: false,
            saving: false,
        };
    },
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
        weekdays() {
            return getWeekdays(this.quest.activityDates);
        },
        questExperiences() {
            const result = [];
            if (this.quest.experiences && this.quest.experiences.length) {
                this.quest.experiences.forEach(experience => result.push(experience.name));
            }
            return result;
        },
        rhythmTitle() {
            return this.quest.rhytm ? this.quest.rhytm.title : '';
        },
        isActivateBtnVisible() {
            if (this.showActivateButton && !this.isVisibleTipsView) {
                return true;
            }
            if (this.isVisibleTipsView) {
                return false;
            }
            const endDate = moment(this.quest.endDate.date);
            return this.quest.isActive == false && moment().isBefore(endDate) ? true : false;
        },
    },
    methods: {
        ...mapActions('questList', ['activateQuest', 'addQuestToGroup']),
        onActivateQuestClick() {
            this.activated = true;
            this.saving = true;
            this.activateQuest(this.questId)
                .then(quest => {
                    this.savedQuest = quest;
                    if (this.showTipsView) {
                        this.isVisibleTipsView = true;
                    } else {
                        this.dialog = false;
                    }
                })
                .catch(() => {
                    // TODO: show error notification
                })
                .finally(() => {
                    this.saving = false;
                });
        },
    },
    watch: {
        dialog(dialog) {
            if (dialog) {
                ActivityModel.getOne(this.questId, {
                    params: {
                        'response-group': 'activity_editor',
                    },
                }).then(quest => {
                    this.quest = quest;
                });
            } else {
                if (this.savedQuest) {
                    this.addQuestToGroup({ quest: this.savedQuest, group: 'activeQuests' });
                }
                this.$emit('on-dialog-hide', { isActive: this.activated });
                this.quest = null;
                this.activated = false;
                this.isVisibleTipsView = false;
            }
        },
    },
};
</script>
